import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationCreateProjectFolderArgs,
  BackendProjectFolder,
} from 'src/types/backend';

import { FRAGMENT_PROJECT_FOLDER } from './schema';

const MUTATION = gql`
  mutation CreateProjectFolder($workspaceId: ID!, $name: String!) {
    createProjectFolder(workspaceId: $workspaceId, name: $name) {
      ...ProjectFolder
    }
  }
  ${FRAGMENT_PROJECT_FOLDER}
`;

type Variables = BackendMutationCreateProjectFolderArgs;
type Result = BackendProjectFolder;

export const createProjectFolder = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
